export default "__VITE_ASSET__B$BbZI9d__"